import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Confirmation, Input, TextArea } from 'freemium-ui';
import { ConfirmationBody } from 'shared/globals';
import { ConfirmationDesc } from '../../style';
import { SurveyTemplateDescriptionFormType } from 'shared/types';

export type TemplateDescriptionFormProps = {
  isLoading?: boolean;
  onSubmit: (val: SurveyTemplateDescriptionFormType) => void;
  onDismiss: () => void;
  title: string;
  description?: string;
  confirmButtonText?: string;
};

export const TemplateDescriptionForm = ({
  isLoading,
  onSubmit,
  onDismiss,
  confirmButtonText,
  title,
  description,
}: TemplateDescriptionFormProps) => {
  const {
    handleSubmit,
    register,
    formState: { submitCount, errors },
  } = useFormContext<SurveyTemplateDescriptionFormType>();

  return (
    <Confirmation
      width="540px"
      isOpen
      onDismiss={onDismiss}
      confirmButtonDisabled={isLoading}
      cancelButtonDisabled={isLoading}
      title={title}
      cancelButtonText="Cancel"
      confirmButtonText={confirmButtonText || 'Save'}
      onConfirm={() =>
        handleSubmit(
          (val) => onSubmit(val),
          (err) => console.log('ERR', err),
        )()
      }
    >
      <ConfirmationBody style={{ color: 'var(--base-color)' }}>
        {description && <ConfirmationDesc>{description}</ConfirmationDesc>}
        <Input
          {...register('name')}
          label="Name"
          inline
          isErrored={submitCount > 0 && Boolean(errors.name?.message)}
          errorText={
            submitCount > 0 && errors.name?.message ? errors.name.message : ''
          }
        />
        <TextArea
          {...register('desc')}
          label="Description"
          placeholder="Enter template description"
          isErrored={submitCount > 0 && Boolean(errors.desc?.message)}
          errorText={
            submitCount > 0 && errors.desc?.message ? errors.desc.message : ''
          }
        />
      </ConfirmationBody>
    </Confirmation>
  );
};

export default TemplateDescriptionForm;
